<template>
  <section>
    <h1 class="title has-text-primary">
      Signup for Mission: "{{$route.query.missionName}}"
    </h1>

    <section>
      <div class="note">(*) Signifies fields that are required to complete registration</div>
      <b-field label="Vaccination Checklist (*)">
        <b-field grouped group-multiline>
          <template v-for="vaccine in vaccinationList">
            <b-checkbox
              v-bind:key=vaccine
              v-bind:native-value=vaccine
              v-model="form.selectedVaccinations">{{vaccine.charAt(0).toUpperCase() + vaccine.slice(1)}}
            </b-checkbox>
            <b-tooltip class="vaccine-date" label="Approximate date of vaccination">
              <b-datepicker v-model="form.vaccineDate[vaccine]"
                            icon="calendar">
              </b-datepicker>
            </b-tooltip>
          </template>
        </b-field>
      </b-field>

      <b-field class="margin-top-scrubs" grouped group-multiline>
        <b-field label="Scrub Top (*)">
          <b-select v-model="form.scrubTopSize">
          <!-- <b-select v-model="form.scrubTopSize" v-validate="'required'"> -->
            <option value="xs">XS</option>
            <option value="s">S</option>
            <option value="m">M</option>
            <option value="l">L</option>
            <option value="xl">XL</option>
            <option value="xxl">XXL</option>
          </b-select>
        </b-field>
        <b-field id="scrub-bottom" label="Scrub Bottom (*)">
          <b-select v-model="form.scrubBottomSize">
          <!-- <b-select v-model="form.scrubBottomSize" v-validate="'required'"> -->
            <option value="xs">XS</option>
            <option value="s">S</option>
            <option value="m">M</option>
            <option value="l">L</option>
            <option value="xl">XL</option>
            <option value="xxl">XXL</option>
          </b-select>
        </b-field>
      </b-field>

      <b-tooltip label="Please enter any airline and the associated frequent
      flyer number so we can give points to your account when booking your flight"
        multilined
      >
        <b-field label="Airline and Frequent Flyer Number (*)">
          <b-input
            type="textarea"
            v-model="form.airlineInfo"
            placeholder="Airline: Frequent Flyer Number, Exp: American Airlines: 123567, Jet Blue: 281982"
          >
          </b-input>
        </b-field>
      </b-tooltip>

      <div class="special-request margin-top">
        <b-field label="Special Request">
          <b-input
            type="textarea"
            v-model="form.specialRequestComment">
          </b-input>
        </b-field>
      </div>
      <div class="margin-top-waiver margin-top waiver">
        <b-field label="Waiver">
          <p>Please download the <a href="https://s3.amazonaws.com/public.test.whausa.net/default_waiver.pdf"
                                    target="_blank">code of conduct</a>,
            print it, sign it, and upload it here.</p>
          <UploadAndViewFile
            s3UploadCategory="waivers"
            :prefix="this.form.missionId + '-codeOfConduct'"
            btnViewText="View Signed Code of Conduct"
            />
          <p>Please download the <a href="https://s3.amazonaws.com/public.test.whausa.net/default_waiver.pdf"
                                    target="_blank">Terms and Conditions</a>,
            print it, sign it, and upload it here.</p>
          <UploadAndViewFile
            s3UploadCategory="waivers"
            :prefix="this.form.missionId + '-termsAndConditions'"
            btnViewText="View Signed Terms and Conditions"
          />
        </b-field>
      </div>
    </section>

    <div class="form-action-buttons">
      <button v-if="!formFilledCompletely()" class="button save-button is-primary" @click="save">Save</button>
      <button v-if="formFilledCompletely()" class="button save-button is-primary" @click="save">Complete Application
      </button>
    </div>

  </section>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import ApiUtil from '@/utils/ApiUtil';
import InfoPuller from '@/utils/InfoPuller';
import ValidationUtil from '@/utils/ValidationUtil';
import UploadAndViewFile from '@/components/UploadAndViewFile';

export default {
  components: {
    UploadAndViewFile,
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  data() {
    return {
      vaccinationList: ['Yellow Fever', 'Hepatitis A' ,'Hepatitis B', 'Tetanus', 'Japanese Encephalitis'],
      passportFile: null,
      passportImage: null,
      form: {
        selectedVaccinations: [],
        vaccineDate: {},
        airlineInfo: null,
        scrubTopSize: null,
        scrubBottomSize: null,
        specialRequestComment: null,
        missionId: this.$route.params.missionId,
      },
    };
  },
  async created() {
    const mission = await ApiUtil.getMission(this.$route.params.missionId);
    const { userId } = await InfoPuller.getUserFromState(this.user);
    const missionGoer = mission.missionGoers[userId];
    Object.keys(missionGoer)
      .forEach((key) => {
        if (key === 'vaccineDate') {
          const vacDate = {};
          Object.keys(missionGoer.vaccineDate)
            .forEach((vac) => {
              vacDate[vac] = new Date(missionGoer.vaccineDate[vac]);
            });
          this.form.vaccineDate = vacDate;
        } else {
          this.form[key] = missionGoer[key];
        }
      });
  },
  methods: {
    ...mapMutations(['setIsLoading']),
    async save() {
      await this.saveMissionGoer(() => {
        this.$toast.open('Saved!');
      });
    },
    async saveMissionGoer(toastFunction) {

      // const valid = await this.$validator.validateAll();

      // const valid = this.$validator.validateAll().then((result) => {
      //   if (result) {
      //     this.$toast.open({
      //       message: 'Form is valid!',
      //       type: 'is-success',
      //       position: 'is-bottom'
      //     })
      //     return;
      //   }
      //   this.$toast.open({
      //     message: 'Form is not valid! Please check the fields.',
      //     type: 'is-danger',
      //     position: 'is-bottom'
      //   })
      // });

      // if( !valid ) this.$toast.open({
      //   message: 'Form is not valid! Please check the fields.',
      //   type: 'is-danger',
      //   position: 'is-bottom'
      // })

      // if( !valid ) return null; // TO-DO: Enable save documents before validation

      const { missionId } = this.$route.params;
      const missionGoerInfo = this.form;
      delete missionGoerInfo.missionId;

      missionGoerInfo.userId = this.user.userId;
      missionGoerInfo.approved = false;
      missionGoerInfo.email = this.user.email;

      await ApiUtil.userSignUpForMission(missionGoerInfo, missionId);

      toastFunction();

      this.$router.push({ name: 'missions' });
    },
    formFilledCompletely() {
      return ValidationUtil.isMissionGoerApplicationCompleted(this.user, this.form.missionId, this.form);
    },
  },
};
</script>

<style lang="scss">
  @import '../../common/inputFieldStyles.scss';

  .header {
    font-weight: bold;
    display: block !important;
    margin-bottom: 5px;
  }

  .special-request {
    width: 300px;
  }

  .form-action-buttons {
    margin-top: 20px;
  }

  #scrub-bottom {
    margin-left: 15px !important;
  }

  .save-button {
    margin-right: 6px;
  }

  .note {
    margin-bottom: 10px;
  }

  .margin-top-scrubs {
    margin-top: 30px;
  }

  .margin-top {
    margin-top: 10px;
  }

  .waiver .has-addons {
    display: block !important;
  }

  p {
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .vaccine-date {
    margin-left: 10px;
    width: 170px;

    .datepicker {
      margin-right: 20px;
    }
  }
</style>
